module.exports = __webpack_public_path__ + "img/steval-harvest1_mcu_demo_1.3d3abb90.png";